module.exports = __webpack_public_path__ + "static/media/favourite.5cb32b6f.svg";